export default "__VITE_ASSET__CaFoqaqN__"